import * as types from "./actionTypes";

export function userSignedInSuccess(signedinuserobject) {
  return {
    type: types.USER_SIGNED_IN_SUCCESS,
    value: signedinuserobject
  };
}

export function userSignedOutSuccess(signedinuserobject) {
  return {
    type: types.USER_SIGNED_OUT_SUCCESS,
    signedinuserobject: signedinuserobject
  };
}
